import { render, staticRenderFns } from "./promotion-products.vue?vue&type=template&id=3954a8d4&scoped=true"
import script from "./promotion-products.vue?vue&type=script&lang=js"
export * from "./promotion-products.vue?vue&type=script&lang=js"
import style0 from "./promotion-products.vue?vue&type=style&index=0&id=3954a8d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3954a8d4",
  null
  
)

export default component.exports